


















import { BoolFilterObj } from "@/components/Filter/FilterGenerator";
import { getTranslationMixin } from "@/mixins/getTranslationMixin";

export default {
  name: "BoolFilter",
  props: {
    item: BoolFilterObj,
    parentName: String
  },
  mixins: [getTranslationMixin],
  data() {
    return {
      selected: 0
    };
  },
  computed: {
    getCheckboxId() {
      return "inlineCheckbox" + this.item.key + this.parentName;
    }
  },
  methods: {
    onClick() {
      this.item.value = !this.item.value;
      if (this.item.parentKey > -1) {
        this.$store.dispatch("updateFilterToCollection", this.item);
      } else {
        this.$store.dispatch("addFilter", this.item);
      }
    }
  }
};
